import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { userSettings, UserLoggedIn, UserName, UserPerm, UserVideoToken, UserCanSeeVid, UserCanSeeAi, UserCanSeeSolo, UserAlertToken, UserCanSetAnalytics, UserCanSetChannel,UserCanSetDaynamicChannel, UserCameraAdmin } from '../common/settings';
import { MsgMngrService } from '../msg/msg-mngr.service';
import { SoundMsgMngrService } from '../msg/sound-msg-mngr.service';
import { OverlayPanelsService } from './overlay-panels.service';
import { aspMngr } from '../asp/AspMngr';
import * as enums from '../common/enums';

export class LoggedInData {
  userName: string = 'nouser';
  fullName: string = 'No User';
}

@Injectable({
  providedIn: 'root'
})
export class SessionService {

  static LOGIN_PATH = 'login';
  static MAIN_PATH = 'app';

  private loggedIn: boolean = false;
  private loggedInData = new LoggedInData();

  constructor(private router: Router, private dialog: MatDialog, private msgMngr: MsgMngrService, private soundMsgMngr: SoundMsgMngrService, private overlayPanelsSvc: OverlayPanelsService) {
    router.events.subscribe((event) => {
      let navEndEvent = event as NavigationEnd;
      if (navEndEvent) {
        if (navEndEvent.url == `/${SessionService.LOGIN_PATH}`)
          this.loggedIn = false;
      }
    });
  }

  isLoggedIn(): boolean {
    return this.loggedIn;
  }

  loggedInUserData(): LoggedInData {
    return this.loggedInData;
  }

  defaultUserName(): string {
    return userSettings.userName ? userSettings.userName : '';
  }

  setLoggedIn(userName?: string, perm?: enums.Permission) {
    if (this.getIsUserLoggedIn() == true) {
      this.loggedIn = true;
      if (userName == undefined)
        userName = sessionStorage.getItem(UserName);
      this.loggedInData.userName = userName;
      this.loggedInData.fullName = userName;
      if (userSettings)
        userSettings.getUserCredsFromSession();
      this.showMainPage();
    }
    else
      this.showLoginPage();
  }

  getIsUserLoggedIn(): boolean {
    let val = sessionStorage.getItem(UserLoggedIn);
    if (val == null) val = 'false';
    let isUserLoggedIn = val == 'true' ? true : false;
    return isUserLoggedIn;
  }

  setIsUserLoggedIn(val: boolean) {
    sessionStorage.setItem(UserLoggedIn, val == true ? 'true' : 'false');
  }

  setUserLoggedIn(isLoggedIn: boolean, name?: string, perm?: enums.Permission, videoToken?: string, alertToken?: string) {
    sessionStorage.setItem(UserLoggedIn, isLoggedIn.toString());
    if (name != undefined)
      sessionStorage.setItem(UserName, name);
    if (perm != undefined)
      sessionStorage.setItem(UserPerm, perm.toString());
    if (videoToken != undefined)
      sessionStorage.setItem(UserVideoToken, videoToken);
    if (alertToken != undefined)
      sessionStorage.setItem(UserAlertToken, alertToken); 
  }

  setUserViewPriv(perms: any) {
    if (perms.canSeeVid != undefined)
      sessionStorage.setItem(UserCanSeeVid, perms.canSeeVid.toString());
    if (perms.canSeeAi != undefined)
      sessionStorage.setItem(UserCanSeeAi, perms.canSeeAi.toString());
    if (perms.canSeeSol != undefined)
      sessionStorage.setItem(UserCanSeeSolo, perms.canSeeSol.toString());
    if (perms.canSetChannel != undefined)
      sessionStorage.setItem(UserCanSetChannel, perms.canSetChannel.toString());
    if (perms.canSetDaynamicChannel != undefined)
      sessionStorage.setItem(UserCanSetDaynamicChannel, perms.canSetDaynamicChannel.toString());
    if (perms.canSetAnalytics != undefined)
      sessionStorage.setItem(UserCanSetAnalytics, perms.canSetAnalytics.toString());
    if (perms.cameraAdmin != undefined)
      sessionStorage.setItem(UserCameraAdmin, perms.cameraAdmin.toString());
  }

  setLoggedoff() {
    this.loggedIn = false;
    this.setIsUserLoggedIn(false);
    window.location.reload();

    // this.leaveMainPage();
    // this.showLoginPage();
  }

  showLoginPage() {
    this.router.navigateByUrl(`/${SessionService.LOGIN_PATH}`);
  }

  isLoginPageActive() {
    return this.router.isActive(`/${SessionService.LOGIN_PATH}`, true);
  }

  showMainPage() {
    this.router.navigateByUrl(`/${SessionService.MAIN_PATH}`);
    // if (aspMngr)
    //   aspMngr.deleteAllObjects();
    // MapMngr.redrawAllMaps();
    // MapMngr.redrawAllBackground();
  }

  isMainPageActive() {
    return this.router.isActive(`/${SessionService.MAIN_PATH}`, true);
  }

  leaveMainPage() {
    this.dialog.closeAll();
    this.overlayPanelsSvc.closeAll();
    this.msgMngr.close();
    this.soundMsgMngr.disconnect();
    aspMngr.deleteAllObjects();
  }
}
